const TextDefaultProperyPalette = ({text}: {text: GeometricShape}) => {
    return(<></>)
}
const createDefaultPropertyPalette = (text: GeometricShape) => {
  return <TextDefaultProperyPalette text={text} />;
};

export default createDefaultPropertyPalette;